import React from "react";



const InstitutionalPlanner = () => {
    const pdfFiles = [
        { name: 'Institutional Planner Primary, HGS school Bhopal ', url: '../newdocuments/Institutional Planner H.G. Bhopal.docx'},
        { name: 'Institutional Planner Senior, HGS school Bhopal', url: '../newdocuments/Institutional Planner H.G. Bhopal.docx'},
        { name: 'Institutional Planner, HGS school Bhimtal', url: '../disclosure2026/Institutional Planner Template 2026 (1).docx'},
        { name: 'Institutional Planner, HGS school Anangpur', url: '../newdocuments/institutional planner 25-26 anagpur.docx'},
        { name: 'Institutional Planner, HGS school Palla Nuh', url: '../newdocuments/HGS Palla, Nuh Institutional Planner 2025-26.pdf'},
        { name: 'Institutional Planner, HGS school Varansi', url: '../newdocuments/Institutional Planner 2025-26 Varanasi.pdf'},
        { name: 'Institutional Planner, HGS school Jammu', url: '../newdocuments/INSTITUTIONAL PLANER  2025 Jammu.xlsx'},
        { name: 'Institutional Planner, HGS school Faridabad', url: '../newdocuments/HGS Institutional planner 26-27 with Examination.docx'},
      ];
 
  return (
    <div className="home_main">
      <div className="pdf-container">
      <table className="pdf-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Filename</th>
            <th>Link To Documents</th>
          </tr>
        </thead>
        <tbody>
          {pdfFiles.map((file, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{file.name}</td>
              <td>
                <a href={file.url} target="_blank" rel="noopener noreferrer">
                  View
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

      
    </div>
  );
};

export default InstitutionalPlanner;
